module.exports = __webpack_public_path__ + "static/media/sg4cr73.4f90c729.png";